// Web Audio合成によるサウンド管理
// 本物のBGM/SFXファイルが揃ったらここに load 処理を追加して差し替える

type SfxName = 'sword' | 'hit' | 'damage' | 'pickup' | 'chest' | 'death';

export class SoundManager {
  private audioCtx: AudioContext | null = null;
  private muted = false;

  private ensureContext(): AudioContext | null {
    if (this.muted) return null;
    if (!this.audioCtx) {
      try {
        const Ctor =
          window.AudioContext ||
          (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
        this.audioCtx = new Ctor();
      } catch {
        this.muted = true;
        return null;
      }
    }
    return this.audioCtx;
  }

  toggleMute(): void {
    this.muted = !this.muted;
  }

  play(name: SfxName): void {
    const ctx = this.ensureContext();
    if (!ctx) return;
    const now = ctx.currentTime;
    const preset = SFX_PRESETS[name];
    preset.forEach((step) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = step.type;
      osc.frequency.setValueAtTime(step.freq, now + step.t);
      if (step.toFreq != null) {
        osc.frequency.linearRampToValueAtTime(step.toFreq, now + step.t + step.dur);
      }
      gain.gain.setValueAtTime(0, now + step.t);
      gain.gain.linearRampToValueAtTime(step.vol, now + step.t + 0.005);
      gain.gain.linearRampToValueAtTime(0, now + step.t + step.dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + step.t);
      osc.stop(now + step.t + step.dur + 0.02);
    });
  }
}

interface ToneStep {
  t: number;
  freq: number;
  toFreq?: number;
  dur: number;
  vol: number;
  type: OscillatorType;
}

const SFX_PRESETS: Record<SfxName, ToneStep[]> = {
  // 剣の振り：ピシュッと下降音
  sword: [{ t: 0, freq: 1200, toFreq: 600, dur: 0.08, vol: 0.06, type: 'triangle' }],
  // ヒット：短いビープ
  hit: [{ t: 0, freq: 660, dur: 0.05, vol: 0.08, type: 'square' }],
  // プレイヤー被弾：低めの嫌な音
  damage: [{ t: 0, freq: 180, dur: 0.2, vol: 0.12, type: 'sawtooth' }],
  // アイテム取得：明るい上昇音
  pickup: [
    { t: 0, freq: 660, dur: 0.06, vol: 0.06, type: 'triangle' },
    { t: 0.06, freq: 990, dur: 0.08, vol: 0.06, type: 'triangle' },
  ],
  // 宝箱：少し豪華に
  chest: [
    { t: 0, freq: 523, dur: 0.08, vol: 0.06, type: 'triangle' },
    { t: 0.08, freq: 659, dur: 0.08, vol: 0.06, type: 'triangle' },
    { t: 0.16, freq: 784, dur: 0.16, vol: 0.07, type: 'triangle' },
  ],
  // 死亡：下降ジングル
  death: [
    { t: 0, freq: 440, dur: 0.15, vol: 0.1, type: 'sawtooth' },
    { t: 0.15, freq: 330, dur: 0.15, vol: 0.1, type: 'sawtooth' },
    { t: 0.3, freq: 220, dur: 0.3, vol: 0.12, type: 'sawtooth' },
  ],
};
